// Set value to localStorage
export function setLocalStorage(key, value) {
  localStorage.setItem(key, value);
}
  
// Get value from localStorage
export function getLocalStorage(key) {
  var value = "";
  if (value = localStorage.getItem(key)) {
    return value;
  }
  return false;
}


// Set JSON to localStorage
export function setJSONLocalStorage(key, value) {
  var object = {"object": value, "timestamp": new Date().getTime()}
  localStorage.setItem(key, JSON.stringify(object));
}
  
// Get JSON from localStorage
export function getJSONLocalStorage(key, timeout_days=7) {
  var value = "";
  if (value = localStorage.getItem(key)) {
    var value_parsed = JSON.parse(value)

    // Get time difference
    var dateString = new Date(value_parsed.timestamp);
    var now = new Date();
    var time_dif_seconds = (now.getTime() - dateString.getTime()) / 1000;
    var max_time_dif_seconds = 60*60*24*timeout_days; // 1 week

    // Compare time difference
    if (max_time_dif_seconds > time_dif_seconds) {
      return value_parsed.object;
    }
    return [];
  }
  return false;
}


// Set value to sessionStorage
export function setSessionStorage(key, value) {
  sessionStorage.setItem(key, value);
}

// Get value from sessionStorage
export function getSessionStorage(key) {
  var value = "";
  if (value = sessionStorage.getItem(key)) {
    return value;
  }
  return false;
}


// Set JSON to sessionStorage
export function setJSONSessionStorage(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
}

// Get JSON from sessionStorage
export function getJSONSessionStorage(key) {
  var value = "";
  if (value = sessionStorage.getItem(key)) {
    return JSON.parse(value);
  }
  return false;
}


// Set value to localStorage
export function setToken(token) {
  localStorage.setItem("token", token);
}
  
// Get value from localStorage
export function getToken() {
  var value = "";
  if (value = localStorage.getItem("token")) {
    return value;
  }
  return "";
}


// Format UTC datetime to locale datetime
export function formatDatetime(timestamp) {
    var date = new Date(timestamp.slice(0, 19) + " UTC");
    var datetime = date.toLocaleDateString() + ", " + date.toLocaleTimeString([], {timeStyle: 'short'})
    return datetime;
}


// Format UTC datetime to locale date
export function formatDate(timestamp) {
    var date = new Date(timestamp.slice(0, 19) + " UTC");
    var datetime = date.toLocaleDateString()
    return datetime;
}